export default __webpack_public_path__ + "static/media/img_corrected.d331a409.png";